import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class CrmEventAttendeeService extends Service {
	constructor(injector: Injector) {
		super("CrmEventAttendee", injector);
	}

	getByEventId(eventId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByEventId/${eventId}`);
	}
}
